import * as loadQueueHelper from '../../document/load-queue'
import Component from './component'

loadQueueHelper.add(function () {
  Component.initDocumentComponentsFromAPI()
})
